import { Link } from 'react-router-dom';

const footerLinks = {
  categories: [
    { label: '电影', path: '/category/movie' },
    { label: '电视剧', path: '/category/tv' },
    { label: '综艺', path: '/category/variety' },
    { label: '动漫', path: '/category/anime' },
  ],
  about: [
    { label: '关于我们', path: '/about' },
    { label: '品牌介绍', path: '/about' },
    { label: '联系我们', path: '/about' },
  ],
  help: [
    { label: '常见问题', path: '/about' },
    { label: '使用帮助', path: '/about' },
    { label: '意见反馈', path: '/about' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-200">
      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-play-circle-fill text-xl text-background-50"></i>
              </div>
              <span className="text-xl font-heading font-bold text-background-50 whitespace-nowrap">
                90影院
              </span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed">
              汇聚8090影院电影、电视剧、综艺、动漫等最新热播影视，免费在线观看，高清不缓冲，全集不断更新。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4 font-heading">
              影视分类
            </h4>
            <ul className="space-y-2">
              {footerLinks.categories.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4 font-heading">
              关于
            </h4>
            <ul className="space-y-2">
              {footerLinks.about.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.path}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4 font-heading">
              帮助
            </h4>
            <ul className="space-y-2">
              {footerLinks.help.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.path}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-800">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-500">
              &copy; {new Date().getFullYear()} 90影院. All Rights Reserved.
            </p>
            <p className="text-xs text-background-500">
              本站所有影视内容均来自互联网，仅供交流学习使用
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}